function Authoriser(authoriser_hash) {
  this.lab_user = authoriser_hash.lab_user;
  this.global_client_permissions = authoriser_hash.global_client_permissions || [];
  this.has_client_permission = code => {
    if (this.lab_user) return true;
    return this.global_client_permissions.includes(code);
  };
}

export default Authoriser;
